const CopyIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Icon/copy-paste'>
      <g id='Vector'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.0835 2.50008C2.0835 1.34949 3.01624 0.416748 4.16683 0.416748H12.5002C13.6508 0.416748 14.5835 1.34949 14.5835 2.50008V14.1667C14.5835 15.3173 13.6508 16.2501 12.5002 16.2501H4.16683C3.01624 16.2501 2.0835 15.3173 2.0835 14.1667V2.50008ZM4.16683 1.25008C3.47647 1.25008 2.91683 1.80973 2.91683 2.50008V14.1667C2.91683 14.8571 3.47647 15.4167 4.16683 15.4167H12.5002C13.1905 15.4167 13.7502 14.8571 13.7502 14.1667V2.50008C13.7502 1.80973 13.1905 1.25008 12.5002 1.25008H4.16683Z'
          fill='black'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.8335 3.75008H14.1668V2.91675H15.8335C16.9841 2.91675 17.9168 3.84949 17.9168 5.00008V16.6667C17.9168 17.8173 16.9841 18.7501 15.8335 18.7501H7.50016C6.34957 18.7501 5.41683 17.8173 5.41683 16.6667V15.8334H6.25016V16.6667C6.25016 17.3571 6.80981 17.9167 7.50016 17.9167H15.8335C16.5239 17.9167 17.0835 17.3571 17.0835 16.6667V5.00008C17.0835 4.30973 16.5239 3.75008 15.8335 3.75008Z'
          fill='black'
        />
      </g>
    </g>
  </svg>
)

export default CopyIcon
